module.exports = __webpack_public_path__ + "img/blog-03.a99f1de7.jpg";